import apiClient from "../apiClient";
import { apiBaseUrl } from "../../config";

export const getSettings = async () => {
  const url = `${apiBaseUrl}/config-admin/`;
  return apiClient.get(url).then((response) => {
    return response;
  });
};

export const createSettings = async (collectionId, payload) => {
  const url = `${apiBaseUrl}/config-admin/${collectionId}`;
  return apiClient.post(url, payload).then((response) => {
    return response;
  });
};

export const updateSettings = async (collectionId, documentId, payload) => {
  const url = `${apiBaseUrl}/config-admin/${collectionId}/${documentId}`;
  return apiClient.put(url, payload).then((response) => {
    return response;
  });
};
